module.exports = __webpack_public_path__ + "static/media/guc_logo.f2bff21d.png";